"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDebouncedValue = useDebouncedValue;

var _react = require("react");

function useDebouncedValue(dynamicValue) {
  const [state, onChange] = (0, _react.useState)(dynamicValue.value);
  (0, _react.useEffect)(() => {
    const timeoutId = window.setTimeout(() => {
      onChange(dynamicValue.value);
    });
    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [dynamicValue.value]);
  return state;
}
//# sourceMappingURL=useDebouncedValue.js.map